/* Update in SalesView as well */
export enum PricingVisibility {
  Detailed = 'detailed', // Full pricing visibility
  EmailOnly = 'email-only', // Pricing is visible only on the email
  Summarized = 'summarized', // Show totals, but hides line item prices
  SummarizedRange = 'summarized-range', // Show range, but hides line item prices
  SummarizedHideLineItems = 'summarized-hide-line-items', // Show totals, but hides line items completely
  SummarizedRangeHideLineItems = 'summarized-range-hide-line-items', // Show range, but hides line items completely
  SummarizedWithProtectedLineItems = 'summarized-with-protected-line-items', // Summarized pricing is shown on the configurator. Full pricing is shown when logged into SalesTool.
  Protected = 'protected', // Hide totals and line item prices if no sales rep. is logged in
  ProtectedRange = 'protected-range', // Pricing is visible as a range, hides line item prices. Full pricing is shown when logged into SalesTool
  Hidden = 'hidden', // Hide totals and line item prices
  HiddenSiteSummarizedEmail = 'hidden-site-summarized-email',
  HiddenSiteSummarizedSiteHideLineItemsEmail = 'hidden-site-summarized-hide-line-items-email',
}
